// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'Serviços',
    url: '#services',
  },
  {
    label: 'Entregas',
    url: '#works',
  },
  {
    label: 'Allune',
    url: '#about-me-section',
  },
  {
    label: 'Testemunhos',
    url: '#testimonials-section',
  },
  {
    label: 'Fale conosco',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/agencia.allune/',
  },
];

const resourceLinks = [
  {
    label: 'Huy Nguyen (the ui designer)',
    url: 'https://www.huyng.xyz',
  },
  {
    label: 'Pillarstack',
    url: 'https://www.pillarstack.com',
  },
  {
    label: 'Figma Template',
    url: 'https://www.figma.com/community/file/1328038510191576951/project-starter-template',
  },
];

const heroText =
  'Allune';

const locationPlace = `12°58'16.0"S 38°30'39.0"W`;
const locationCountry = 'Brasil, Bahia';


// cal.com
const dataCalNamespace = '30min';
const dataCalLink = 'brhoom/30min';
const dataCalConfig =
  '{"layout":"month_view", "theme": "dark", "brand": "#8C8C73"}';

export {
  socialLinks,
  resourceLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
  dataCalNamespace,
  dataCalLink,
  dataCalConfig,
};
